import request from '@/utils/request'

export function list(query) {
    return request({
        url: '/log/rule/list',
        method: 'get',
        params: query
    })
}

export function info(id) {
    return request({
        url: '/log/rule/info/' + id,
        method: 'get'
    })
}

export function save(data) {
    return request({
        url: '/log/rule/save',
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: '/log/rule/update',
        method: 'post',
        data
    })
}

export function remove(data) {
    return request({
        url: '/log/rule/delete',
        method: 'post',
        data
    })
}

